import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
//import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NumberListComponent } from './number-list/number-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NumberCoordinatesComponent } from './number-coordinates/number-coordinates.component';
import { LotteryParamsComponent } from './lottery-params/lottery-params.component';
import { LotteryParamOptionsComponent } from './lottery-params/lottery-params-options/lottery-param-options.component';
import { CoordinatesComponent } from './coordinates/coordinates.component';
import { LotteryParamComponent } from './lottery-param/lottery-param.component';
import { CardBlockPositionsComponent } from './card-block-positions/card-block-positions.component';
import { NumberCoordinates2Component } from './number-coordinates2/number-coordinates2.component';
import { PrintCardConfigComponent } from './print-card-config/print-card-config.component';
import { NumbersByBetComponent } from './numbers-by-bet/numbers-by-bet.component';
import { GridNumbersComponent } from './grid-numbers/grid-numbers.component';
import { FilterEditorComponent } from './filter-editor/filter-editor.component';
import { FilterStatisticsComponent } from './filter-statistics/filter-statistics.component';
import { IntelliControlsModule } from '../intelli-controls/intelli-controls.module';
import { PortletModule } from '../../../views/partials/content/general/portlet/portlet.module';
import {  SoftProgressBarLilacComponent, SoftProgressBarBlueComponent, SoftProgressBarGreenComponent, SoftProgressBarRedComponent } from './soft-progress-bar/soft-progress-bar.component';
import { JockerListComponent } from './jocker-list/jocker-list.component';
import { AwardParamsComponent } from './award-params/award-params.component';
import { LottolocaNumberListComponent } from './lottoloca-number-list/lottoloca-number-list.component';
import { ManualParamsComponent } from './manual-params/manual-params.component';
import { FrequencyStatisticsComponent } from './frequecy-statistics/frequecy-statistics.component';
import { DelayStatisticsComponent } from './delay-statistics/delay-statistics.component';
import { AwardLevelParamsComponent } from './award-level-params/award-level-params.component';
import { GridJockersComponent } from './grid-jockers/grid-jockers.component';
import { MatDialogModule } from '@angular/material/dialog';
import { SpoltiControlsModule } from '../spolti-controls/spolti-controls.module';


@NgModule({
  imports: [
     CommonModule,
   IntelliControlsModule, 
     PortletModule,
     FormsModule,
     ReactiveFormsModule,

    MatNativeDateModule,
    MatInputModule,
    MatAutocompleteModule,
    MatButtonModule, 
    MatToolbarModule,
    MatIconModule,
    MatMenuModule,
    MatCardModule,
    MatSelectModule,
    MatDatepickerModule, 
    MatNativeDateModule,
    MatDialogModule,
    MatFormFieldModule,
    MatGridListModule,
    MatDividerModule,
    MatProgressBarModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    SpoltiControlsModule
  ],
  declarations: [ 
    AwardParamsComponent,
    ManualParamsComponent,
    NumberListComponent,
    JockerListComponent,
 
    NumberCoordinatesComponent,
    NumberCoordinates2Component,
    LotteryParamsComponent,
    LotteryParamOptionsComponent,
    CoordinatesComponent,LotteryParamComponent,
    CardBlockPositionsComponent,
    PrintCardConfigComponent,
    NumbersByBetComponent,
    GridNumbersComponent,
    FilterEditorComponent,
    FilterStatisticsComponent,
    SoftProgressBarLilacComponent,
    SoftProgressBarRedComponent,
    SoftProgressBarGreenComponent,
    SoftProgressBarBlueComponent,
    LottolocaNumberListComponent,
    FrequencyStatisticsComponent,
    DelayStatisticsComponent,
    AwardLevelParamsComponent,
    GridJockersComponent],
  exports:[    
    AwardParamsComponent,
    AwardLevelParamsComponent,
    ManualParamsComponent,
    NumberCoordinates2Component,
    JockerListComponent,
    NumberListComponent,
LottolocaNumberListComponent,
    NumberCoordinatesComponent,
    LotteryParamsComponent,LotteryParamComponent,
    LotteryParamOptionsComponent,
    CoordinatesComponent,CardBlockPositionsComponent,
    PrintCardConfigComponent,
    NumbersByBetComponent,
    GridNumbersComponent,
    FilterEditorComponent,
    FilterStatisticsComponent,
    SoftProgressBarLilacComponent,
    SoftProgressBarRedComponent,
    SoftProgressBarGreenComponent,
    SoftProgressBarBlueComponent,
    FrequencyStatisticsComponent,
  DelayStatisticsComponent,
  GridJockersComponent]
    
})
export class ControlsModule { }
